// these UUIDs originate here so we can pass them instead of the amenity name which might change
export const ASK_ABOUT_AN_UPGRADE = 'b9850fdd-552e-4427-b227-da2974a27b76';
export const BAND_PRACTICE_SPACE = 'd0f23b42-e585-4457-ad9d-90420bb4f59c';
export const BOXES_AND_SUPPLIES = '3327b9dc-727f-4771-85b1-c5b3646a1c49';
export const BUDGET_BILLING = '7b94576e-8299-49b0-b56d-5af97f5a324c';
export const BUSINESS_CENTER = '2f7c8ca4-361e-4d2e-8206-f81d95ab39c7';
export const CALL_CENTER = '6125b232-182e-4415-adbd-ba4785a9cb44';
export const CLEAN = '8a8bde16-65d1-41b4-80f3-9e86df3743e7';
export const CLOSETS = '1abe7417-f09e-4493-875c-172b6446f8d6';
export const CONFERENCE_ROOM = '0f465868-ce1d-4c0a-b3b2-604da5679033';
export const CONTACTLESS_CHECKIN = '714f2166-bb7a-41f8-ba4c-8136b79c6e89';
export const CONVENIENT_LOCATION = '95db0803-c539-4b48-b854-7a7a3b534a0c';
export const COVERED = '47a8416e-b854-463c-8fbb-b7bfa034e94c';
export const COVERED_LOADING_BAYS = '56e0d5a2-8656-4fca-984c-8eb9e59947c3';
export const DRIVE_IN_LOADING_BAYS = '2e90b15e-da75-4b5f-96d4-b1a31dec27f5';
export const DRIVE_THRU_LOADING_BAYS = '5d087a60-348d-43cb-bdd1-9c7f5b4126a1';
export const DRIVE_UP_ACCESS = '4a9b61aa-80f6-4124-b7f3-ea772c6036ce';
export const DRIVE_UP_LOADING_BAYS = '6377a3e7-915c-423e-b1db-e60dd8d8a754';
export const DOCK_HIGH_LOADING_BAYS = 'ed0749dd-8638-49ab-94aa-31defa87d32a';
export const DOLLIES_AND_HANDCARTS = '7195beeb-eae8-46d4-b148-eb4cc6358bb3';
export const ECO_FRIENDLY_FACILITY = '97408b73-4ee7-4534-a553-f7267af9e3c3';
export const ELEVATOR_ACCESS = 'cff7924d-3e49-475a-90c2-802b65e9b9d7';
export const EXCELLENT_RATING = '7f1b08c4-bb7a-4f89-af4c-72fe1758fbcc';
export const EXCLUSIVE_ONLINE_RATES = 'fa3a6577-3ca0-4f0b-897d-080490542edd';
export const FENCED_AND_GATED = '2e0f190c-28d5-4be8-8bfc-634222072ddb';
export const FREE_EXTENDED_ACCESS_HOURS = '7da0dca8-43de-41d7-8fd0-136068c42404';
export const FREE_EXTENDED_GATE_ACCESS = '4c6fef64-574e-4ca4-8946-cfcd39efb208';
export const FREE_OFF_STREET_PARKING = '867aa562-41c8-4fb1-a89c-665c2c1a8c82';
export const FRIENDLY = '829d58a1-5b89-431e-b9fe-bc0ac1cc17c7';
export const GROUND_FLOOR = '4b630cb6-b610-4af9-99cb-07d7ffccfedc';
export const HEATED = '047d9706-2755-4b18-a230-5c31ee297b65';
export const INDOOR_UNITS = '9e0a19c7-44a0-42bb-ac60-e1220ceeae8a';
export const INTERIOR_STORAGE = '982e48ae-e27f-46ab-9748-356f039c7384';
export const LIGHT_IN_UNIT = '4408d1ed-2641-483e-9745-29ac50207b14';
export const LOADING_BAY = 'b6142494-3927-4d27-bd10-d60d2d6f8abc';
export const LOCAL_CHARITY_SPONSOR = '457a40b0-8e22-4dc7-b04b-514e545f4d30';
export const LOW_MONTHLY_RATES = '230099c2-9460-45b0-8539-e7f95e86d9d0';
export const MISCELLANEOUS = 'e6e90223-480a-4037-ba0a-e189c748018f';
export const MONTH_TO_MONTH_LEASE = 'ec9a237a-83b5-48d5-a720-3ba887a51bbf';
export const MOVING_CARTS = '32e0d153-8f81-4fc2-bfe4-06ec1e9205ba';
export const MOVING_SUPPLIES_AVAILABLE = '1f440e4b-c89d-477c-b5e4-6d555e83f6bf';
export const NEARBY_LOCATIONS = '5121c5f0-2ee1-45e6-8759-fa80ee5a23bc';
export const NO_CREDIT_CARD_REQUIRED = '146b6f99-4096-4b54-86e3-04940611e74c';
export const NO_DEPOSIT = '8597b292-de30-4fae-807c-ff6314082241';
export const NO_DEPOSIT_REQUIRED = '0a2b1094-7481-419e-89e9-71f0f874f17d';
export const NOW_HIRING = '6615f5f7-6730-4048-a1f3-dbad989349b1';
export const OFFICE_SPACE_FOR_RENT = 'ec6d28d3-e1c2-4ad7-b9ca-a34ee49681de';
export const ONLINE_BILL_PAY = '49a8f641-9a23-4174-8e4f-0f4ca0655f5f';
export const PARKING_FOR_RENT = '96788bd1-71aa-49f0-bbe6-b9040474e5da';
export const PORTABLE_STORAGE = '038d184e-7862-4d23-9329-119f7d12a2f2';
export const QUICK_AND_EASY = '838cfe20-db7e-46a8-994d-3c9550da4c12';
export const RAMP = 'd158a7fe-6add-4861-9908-c01fbc245480';
export const RESIDENT_MANAGER = '27a2a2c9-b48d-42df-b387-f6eb79bee225';
export const RETAIL_SPACE_FOR_RENT = '04ef8aac-16a9-48a8-ac0f-eb9fd2b7ab4f';
export const RV_AND_CAR_AND_BOAT_PARKING = '409625e9-810d-4a7d-a794-6085e609514c';
export const SAFE_AND_SECURE = '5f3a201b-bdc3-44b1-9f30-d4a4f878fed4';
export const SE_HABLA_ESPANOL = '159a19f4-3588-45b5-8f10-eb7f8d64727d';
export const SECURE_ACCESS = 'c5d82ef8-cfb9-4051-80ac-d5c2e5af2db0';
export const SECURE_UNITS = 'f79cefe9-8fac-4cff-924a-896fb7c3a7e9';
export const SECURITY_CAMERA = '252f7472-3ecd-49d5-9f8f-c75db33eb90d';
export const SHIPPING_SERVICES = '244f1246-be7a-4669-8229-22655b016409';
export const TEMPERATURE_CONTROLLED = 'aa412ade-6cf9-414b-8306-0841b68105e5';
export const TRUCK_RENTAL = '219c3a86-3f1b-4ce1-b0ee-51eee848dc00';
export const TWENTY_FOUR_HOUR_ACCESS = '5e4a9c0f-0ec8-4b11-b9c6-134b3e2333ad';
export const TWENTY_FOUR_HOUR_ACCESS_BY_REQUEST = 'a197143d-884b-4cb6-b913-3b7aa1845a6d';
export const TWENTY_FOUR_HOUR_KIOSK = 'f35922b8-dfd2-4167-a031-78daad8fb4b0';
export const UNCOVERED = '7e97498a-840d-48d8-a3f5-68176728e8ed';
export const UPSTAIRS = '4b5d68f8-8dd9-4ac3-9442-346dbe3e5f7d';
export const VARIETY_OF_SIZES = '3f747f0c-2dcb-4bda-b905-7bce8f4bab8f';
export const VIDEO_SURVEILLANCE = 'c79768e7-142c-4a11-bec0-78f92080d703';
export const WELL_LIT = '0f2e032e-4f55-4ca8-8864-2668378daa0c';
export const WINE_STORAGE = '591944e0-830e-48c1-bef4-ec8bf9cf9af5';
export const WORKSHOPS_FOR_RENT = '61f6b4b0-9ce4-471d-a3f3-5637735162ee';
export const CAR_PARKING = '551478db-9ef2-43f5-96c6-9d5e529f706c';
export const CLOSE_TO_NYU = '8fc04e16-42c4-49d9-8547-fae1b3018956';
export const CLOSE_TO_COLUMBIA = 'df808fe3-0c99-4470-8469-5c5e9dc8d20a';
export const CLOSE_TO_FIT = '92ae35c9-c747-4197-9eb7-1495c29bc34c';
export const CLOSE_TO_THE_NEW_SCHOOL = '821eeaa4-73c9-4246-888e-b259f1f7a3dc';
export const CLOSE_TO_FORDHAM_UNIVERSITY = 'd9e89646-cbfe-4075-b8d0-cb37e9ccb076';
export const CLOSE_TO_PACE_UNIVERSITY = '03222059-3c25-48ed-9373-1796060cd3fc';
export const CLOSE_TO_MANHATTAN_SCHOOL_OF_MUSIC = '0727245c-a92f-4237-bfc7-5a6b1a357313';
export const CLOSE_TO_BARNARD_COLLEGE = '0502c3d2-2d75-4e22-a98f-88235e2de841';
export const CLOSE_TO_SVA_NYC_SCHOOL_OF_VISUAL_ARTS = 'cfa7fb4c-870e-4aeb-acfb-a792a428892f';
export const CLOSE_TO_HUNTER_UNIVERSITY = 'bf17f587-4034-4e22-8f72-011bf588d97e';
export const CLOSE_TO_BARUCH_COLLEGE = '175c257c-17b8-4fa3-81e0-a116a0f27d65';

export const AMENITY_IDS = [
  ASK_ABOUT_AN_UPGRADE,
  BAND_PRACTICE_SPACE,
  BOXES_AND_SUPPLIES,
  BUDGET_BILLING,
  BUSINESS_CENTER,
  CALL_CENTER,
  CLEAN,
  CLOSETS,
  CONFERENCE_ROOM,
  CONTACTLESS_CHECKIN,
  CONVENIENT_LOCATION,
  COVERED,
  COVERED_LOADING_BAYS,
  DRIVE_IN_LOADING_BAYS,
  DRIVE_THRU_LOADING_BAYS,
  DRIVE_UP_ACCESS,
  DRIVE_UP_LOADING_BAYS,
  DOCK_HIGH_LOADING_BAYS,
  DOLLIES_AND_HANDCARTS,
  ECO_FRIENDLY_FACILITY,
  ELEVATOR_ACCESS,
  EXCELLENT_RATING,
  EXCLUSIVE_ONLINE_RATES,
  FENCED_AND_GATED,
  FREE_EXTENDED_ACCESS_HOURS,
  FREE_EXTENDED_GATE_ACCESS,
  FREE_OFF_STREET_PARKING,
  FRIENDLY,
  GROUND_FLOOR,
  HEATED,
  INDOOR_UNITS,
  INTERIOR_STORAGE,
  LIGHT_IN_UNIT,
  LOCAL_CHARITY_SPONSOR,
  LOW_MONTHLY_RATES,
  MISCELLANEOUS,
  MONTH_TO_MONTH_LEASE,
  MOVING_CARTS,
  MOVING_SUPPLIES_AVAILABLE,
  NEARBY_LOCATIONS,
  NO_CREDIT_CARD_REQUIRED,
  NO_DEPOSIT,
  NO_DEPOSIT_REQUIRED,
  NOW_HIRING,
  OFFICE_SPACE_FOR_RENT,
  ONLINE_BILL_PAY,
  PORTABLE_STORAGE,
  QUICK_AND_EASY,
  RAMP,
  RESIDENT_MANAGER,
  RETAIL_SPACE_FOR_RENT,
  RV_AND_CAR_AND_BOAT_PARKING,
  SAFE_AND_SECURE,
  SE_HABLA_ESPANOL,
  SECURE_ACCESS,
  SECURE_UNITS,
  SECURITY_CAMERA,
  SHIPPING_SERVICES,
  TEMPERATURE_CONTROLLED,
  TRUCK_RENTAL,
  TWENTY_FOUR_HOUR_ACCESS,
  TWENTY_FOUR_HOUR_ACCESS_BY_REQUEST,
  TWENTY_FOUR_HOUR_KIOSK,
  UNCOVERED,
  UPSTAIRS,
  VARIETY_OF_SIZES,
  VIDEO_SURVEILLANCE,
  WELL_LIT,
  WINE_STORAGE,
  WORKSHOPS_FOR_RENT,
];

const bindRegExp = regex => regex.test.bind(regex);

export const AMENITIES = [
  {
    id: ASK_ABOUT_AN_UPGRADE,
    name: 'Ask About an Upgrade',
    token: 'upgrade',
    featured: true,
    test: bindRegExp(/upgrade/i),
  },
  {
    id: BAND_PRACTICE_SPACE,
    name: 'Band Practice Space',
    token: 'bandPracticeSpace',
    test: bindRegExp(/band practice/i),
  },
  {
    id: BOXES_AND_SUPPLIES,
    name: 'Boxes & Supplies',
    token: 'boxesAndSupplies',
    test: bindRegExp(/(boxes|supplies)/i),
  },
  {
    id: BUDGET_BILLING,
    name: 'Budget Billing',
    token: 'budgetBilling',
    test: bindRegExp(/budget billing/i),
  },
  {
    id: BUSINESS_CENTER,
    name: 'Business Center',
    token: 'businessCenter',
    test: bindRegExp(/business/i),
  },
  {
    id: CALL_CENTER,
    name: 'Call Center',
    token: 'callCenter',
    test: bindRegExp(/call/i),
  },
  {
    id: CAR_PARKING,
    name: 'Car Parking',
    token: 'carparking',
    test: bindRegExp(/car parking/i),
  },
  {
    id: CLEAN,
    name: 'Clean',
    token: 'clean',
    test: bindRegExp(/clean/i),
  },
  {
    id: CLOSETS,
    name: 'Closets',
    token: 'closets',
    test: bindRegExp(/closets/i),
  },
  {
    id: CONFERENCE_ROOM,
    name: 'Conference Room',
    token: 'conferenceRoom',
    test: bindRegExp(/conference/i),
  },
  {
    id: CONTACTLESS_CHECKIN,
    name: 'Contactless Check-in',
    token: 'contactlessCheckIn',
    test: bindRegExp(/contactless/i),
  },
  {
    id: CONVENIENT_LOCATION,
    name: 'Convenient Location',
    token: 'convenientLocation',
    test: bindRegExp(/convenient/i),
  },
  {
    id: COVERED,
    name: 'Covered',
    token: 'covered',
    test: bindRegExp(/^covered$/i),
  },
  {
    id: COVERED_LOADING_BAYS,
    name: 'Covered Loading Bays',
    token: 'coveredLoadingBays',
    test: bindRegExp(/^(covered loading bays)$/i),
  },
  {
    id: DRIVE_IN_LOADING_BAYS,
    name: 'Drive-in Loading Bays',
    token: 'loadingBays',
    test: bindRegExp(/drive(\s|-)?in loading bays/i),
  },
  {
    id: DRIVE_THRU_LOADING_BAYS,
    name: 'Drive-thru Loading Bays',
    token: 'driveThruLoadingBays',
    test: bindRegExp(/drive(\s|-)?thru/i),
  },
  {
    id: DRIVE_UP_ACCESS,
    name: 'Drive-up Access',
    token: 'driveUpAccess',
    test: bindRegExp(/drive(\s|-)?up access/i),
  },
  {
    id: DRIVE_UP_LOADING_BAYS,
    name: 'Drive-up Loading Bays',
    token: 'driveUpLoadingBays',
    test: bindRegExp(/drive(\s|-)?up loading bay/i),
  },
  {
    id: DOCK_HIGH_LOADING_BAYS,
    name: 'Dock-high Loading Bays',
    token: 'dockHighLoadingBays',
    test: bindRegExp(/dock(\s|-)?high/i),
  },
  {
    id: DOLLIES_AND_HANDCARTS,
    name: 'Dollies/Handcarts',
    token: 'dolliesHandcarts',
    test: bindRegExp(/(dolly|dollies|handcart)/i),
  },
  {
    id: ECO_FRIENDLY_FACILITY,
    name: 'Eco-friendly Facility',
    token: 'ecoFriendly',
    test: bindRegExp(/eco(\s|-)?friendly/i),
  },
  {
    id: ELEVATOR_ACCESS,
    name: 'Elevator Access',
    token: 'elevatorAccess',
    test: bindRegExp(/elevator/i),
  },
  {
    id: EXCELLENT_RATING,
    name: 'Excellent Rating',
    token: 'excellentRating',
    test: bindRegExp(/excellent rating/i),
  },
  {
    id: EXCLUSIVE_ONLINE_RATES,
    name: 'Exclusive Online Rates',
    token: 'exclusiveOnlineRates',
    featured: true,
    test: () => false,
  },
  {
    id: FENCED_AND_GATED,
    name: 'Fenced & Gated',
    token: 'fencedAndGated',
    test: bindRegExp(/(fence|gated)/i),
  },
  {
    id: FREE_EXTENDED_ACCESS_HOURS,
    name: 'Free Extended Access Hours',
    token: 'freeExtendedAccessHours',
    featured: true,
    test: () => false,
  },
  {
    id: FREE_EXTENDED_GATE_ACCESS,
    name: 'Free Extended Gate Access',
    token: 'extendedGateAccess',
    test: bindRegExp(/(extended gate|gate access)/i),
  },
  {
    id: FREE_OFF_STREET_PARKING,
    name: 'Free Off Street Parking',
    token: 'freeOffStreetParking',
    test: bindRegExp(/(off street)/i),
  },
  {
    id: FRIENDLY,
    name: 'Friendly',
    token: 'friendly',
    test: bindRegExp(/\w*^friendly/i),
  },
  {
    id: GROUND_FLOOR,
    name: 'Ground Floor',
    token: 'groundFloor',
    test: bindRegExp(/ground/i),
  },
  {
    id: HEATED,
    name: 'Heated',
    token: 'heated',
    test: bindRegExp(/heated/i),
  },
  {
    id: INDOOR_UNITS,
    name: 'Indoor Units',
    token: 'indoorUnits',
    test: bindRegExp(/indoor/i),
  },
  {
    id: INTERIOR_STORAGE,
    name: 'Interior Storage',
    token: 'interiorStorage',
    test: bindRegExp(/interior/i),
  },
  {
    id: LIGHT_IN_UNIT,
    name: 'Light in Unit',
    token: 'lightInUnit',
    test: bindRegExp(/(power|electric|light)/i),
  },
  {
    id: LOCAL_CHARITY_SPONSOR,
    name: 'Local Charity Sponsor',
    token: 'localCharitySponsor',
    test: bindRegExp(/charity/i),
  },
  {
    id: LOW_MONTHLY_RATES,
    name: 'Low Monthly Rates',
    token: 'lowMonthlyRates',
    featured: true,
    test: () => false,
  },
  {
    id: MISCELLANEOUS,
    name: 'Miscellaneous',
    token: 'misc',
    test: str => !AMENITIES
      .filter(amenity => amenity.id !== MISCELLANEOUS)
      .some(amenity => amenity.test(str)),
  },
  {
    id: MONTH_TO_MONTH_LEASE,
    name: 'Month-to-month Lease',
    token: 'monthToMonth',
    featured: true,
    test: bindRegExp(/month(\s|-)?to(\s|-)?month/i),
  },
  {
    id: MOVING_CARTS,
    name: 'Moving Carts',
    token: 'movingCarts',
    test: bindRegExp(/moving carts/i),
  },
  {
    id: MOVING_SUPPLIES_AVAILABLE,
    name: 'Moving Supplies Available',
    token: 'movingSuppliesAvailable',
    featured: true,
    test: () => false,
  },
  {
    id: NEARBY_LOCATIONS,
    name: 'Nearby Locations',
    token: 'nearbyLocations',
    test: bindRegExp(/nearby/i),
  },
  {
    id: NO_CREDIT_CARD_REQUIRED,
    name: 'No Credit Card Required',
    token: 'noCreditCardRequired',
    featured: true,
    test: () => false,
  },
  {
    id: NO_DEPOSIT,
    name: 'No Deposit',
    token: 'noDeposit',
    test: bindRegExp(/no deposit/i),
  },
  {
    id: NO_DEPOSIT_REQUIRED,
    name: 'No Deposit Required',
    token: 'noDepositRequired',
    featured: true,
    test: () => false,
  },
  {
    id: NOW_HIRING,
    name: 'Now Hiring',
    token: 'nowHiring',
    test: bindRegExp(/now hiring/i),
  },
  {
    id: OFFICE_SPACE_FOR_RENT,
    name: 'Office Space for Rent',
    token: 'officeSpace',
    test: bindRegExp(/office space/i),
  },
  {
    id: ONLINE_BILL_PAY,
    name: 'Online Bill Pay',
    token: 'onlineBillPay',
    test: bindRegExp(/(bill pay|pay online)/i),
  },
  {
    id: PARKING_FOR_RENT,
    name: 'Parking for Rent',
    token: 'parkingForRent',
    test: bindRegExp(/parking for rent/i),
  },
  {
    id: PORTABLE_STORAGE,
    name: 'Portable Storage',
    token: 'portableStorage',
    test: bindRegExp(/(portable|mobile)/i),
  },
  {
    id: QUICK_AND_EASY,
    name: 'Quick & Easy',
    token: 'quickEasy',
    test: bindRegExp(/(quick|easy)/i),
  },
  {
    id: RAMP,
    name: 'Ramp',
    token: 'ramp',
    test: bindRegExp(/ramp/i),
  },
  {
    id: RESIDENT_MANAGER,
    name: 'Resident Manager',
    token: 'residentManager',
    test: bindRegExp(/resident manager/i),
  },
  {
    id: RETAIL_SPACE_FOR_RENT,
    name: 'Retail Space for Rent',
    token: 'retailSpace',
    test: bindRegExp(/retail space/i),
  },
  {
    id: RV_AND_CAR_AND_BOAT_PARKING,
    name: 'RV, Car, and Boat Parking',
    token: 'rvCarBoatParking',
    test: bindRegExp(/(rv |boat)/i),
  },
  {
    id: SAFE_AND_SECURE,
    name: 'Safe & Secure',
    token: 'safeAndSecure',
    featured: true,
    test: () => false,
  },
  {
    id: SE_HABLA_ESPANOL,
    name: 'Se Habla Español',
    token: 'seHablaEspanol',
    test: bindRegExp(/(se habla|espanol)/i),
  },
  {
    id: SECURE_ACCESS,
    name: 'Secure Access',
    token: 'secureAccess',
    test: bindRegExp(/secure/i),
  },
  {
    id: SECURE_UNITS,
    name: 'Secure Units',
    token: 'secureUnits',
    featured: true,
    test: bindRegExp(/secure units/i),
  },
  {
    id: SECURITY_CAMERA,
    name: 'Security Camera',
    token: 'securityCamera',
    test: bindRegExp(/camera/i),
  },
  {
    id: SHIPPING_SERVICES,
    name: 'Shipping Services',
    token: 'shippingServices',
    test: bindRegExp(/(shipping|mail)/i),
  },
  {
    id: TEMPERATURE_CONTROLLED,
    name: 'Temperature Controlled',
    token: 'temperatureControlled',
    test: bindRegExp(/(temperature|climate)/i),
  },
  {
    id: TRUCK_RENTAL,
    name: 'Truck Rental',
    token: 'truckRental',
    featured: true,
    test: bindRegExp(/truck/i),
  },
  {
    id: TWENTY_FOUR_HOUR_ACCESS,
    name: '24 Hours Access',
    token: '24HourAccess',
    test: bindRegExp(/24(\s|-)?hour(s)? access/i),
  },
  {
    id: TWENTY_FOUR_HOUR_ACCESS_BY_REQUEST,
    name: '24 Hour Access by Request',
    token: '24HourAccessByRequest',
    featured: true,
    test: () => false,
  },
  {
    id: TWENTY_FOUR_HOUR_KIOSK,
    name: '24 Hour Kiosk',
    token: '24HourKiosk',
    test: bindRegExp(/24 hour kiosk/i),
  },
  {
    id: UNCOVERED,
    name: 'Uncovered',
    token: 'uncovered',
    test: bindRegExp(/^uncovered/i),
  },
  {
    id: UPSTAIRS,
    name: 'Upstairs',
    token: 'upstairs',
    test: bindRegExp(/(upstairs|top floor)/i),
  },
  {
    id: VARIETY_OF_SIZES,
    name: 'Variety of Sizes',
    token: 'varietyOfSizes',
    featured: true,
    test: bindRegExp(/variety of sizes/i),
  },
  {
    id: VIDEO_SURVEILLANCE,
    name: 'Video Surveillance',
    token: 'videoSurveillance',
    featured: true,
    test: bindRegExp(/video surveillance/i),
  },
  {
    id: WELL_LIT,
    name: 'Well Lit',
    token: 'wellLit',
    test: bindRegExp(/well(\s|-)?lit/i),
  },
  {
    id: WINE_STORAGE,
    name: 'Wine Storage',
    token: 'wineStorage',
    test: bindRegExp(/wine/i),
  },
  {
    id: WORKSHOPS_FOR_RENT,
    name: 'Workshops for Rent',
    token: 'workshops',
    test: bindRegExp(/workshop/i),
  },
  {
    id: LOADING_BAY,
    name: 'Loading Bay',
    token: 'loadingBay',
    test: bindRegExp(/loading bay/i),
  },
  {
    id: CLOSE_TO_NYU,
    name: 'Close to NYU',
    token: 'closeToNyu',
    test: bindRegExp(/close to nyu/i),
  },
  {
    id: CLOSE_TO_COLUMBIA,
    name: 'Close to Columbia',
    token: 'closeToColumbia',
    test: bindRegExp(/close to columbia/i),
  },
  {
    id: CLOSE_TO_FIT,
    name: 'Close to FIT',
    token: 'closeToFit',
    test: bindRegExp(/close to fit/i),
  },
  {
    id: CLOSE_TO_THE_NEW_SCHOOL,
    name: 'Close to The New School',
    token: 'closeToTheNewSchool',
    test: bindRegExp(/close to the new school/i),
  },
  {
    id: CLOSE_TO_FORDHAM_UNIVERSITY,
    name: 'Close to Fordham University',
    token: 'closeToFordhamUniversity',
    test: bindRegExp(/close to fordham university/i),
  },
  {
    id: CLOSE_TO_PACE_UNIVERSITY,
    name: 'Close to PACE University',
    token: 'closeToPaceUniversity',
    test: bindRegExp(/close to page university/i),
  },
  {
    id: CLOSE_TO_MANHATTAN_SCHOOL_OF_MUSIC,
    name: 'Close to Manhattan School of Music',
    token: 'closeToManhattanSchoolOfMusic',
    test: bindRegExp(/close to manhattan school of music/i),
  },
  {
    id: CLOSE_TO_BARNARD_COLLEGE,
    name: 'Close to Barnard College',
    token: 'closeToBarnardCollege',
    test: bindRegExp(/close to barnard college/i),
  },
  {
    id: CLOSE_TO_SVA_NYC_SCHOOL_OF_VISUAL_ARTS,
    name: 'Close to SVA NYC School of Visual Arts',
    token: 'closeToSvaNyc',
    test: bindRegExp(/close to sva nyc/i),
  },
  {
    id: CLOSE_TO_HUNTER_UNIVERSITY,
    name: 'Close to Hunter University',
    token: 'closeToHunterUniversity',
    test: bindRegExp(/close to hunter university/i),
  },
  {
    id: CLOSE_TO_BARUCH_COLLEGE,
    name: 'Close to Baruch College',
    token: 'closeToBaruchCollege',
    test: bindRegExp(/close to baruch college/i),
  },
];

export const FEATURED_AMENITIES = AMENITIES.reduce((obj, amenity) => ({
  ...obj,
  [amenity.id]: amenity,
}), {});

export const AMENITY_NAMES = AMENITIES.map(amenity => amenity.name);
